import { InputLoad } from "components/InputLoading/inputLoading";
import { SelectBox } from "components/Select/Select";
import { Textbox } from "components/Textbox/Textbox";
import { getDataAsync } from "pages/OfficeAutomation/FormBuilder/api";
import React, { useEffect, useState } from "react";

interface TextInputSettingsProps {
  object: any;
  textType: "text" | "number" | "other";
  modeTextBox: "create" | "view";
  listTypeText: any;
  checkTypeText: (e: string) => void;
  minLengthBox: any;
  maxLengthBox: any;
  Formul?: any;

  systemKeys?:any
}

export const TextInputSettings: React.FC<TextInputSettingsProps> = ({
  object,
  textType,
  modeTextBox,
  listTypeText,
  checkTypeText,
  minLengthBox,
  maxLengthBox,
  Formul,
  systemKeys,

}) => {

    const [newFormula,setNewFormula]=useState(extractSimpleFormula(Formul?.[object?.SystemKey]))
    const [systemUsedInFormula,setSystemUsedInFormula]=useState<any>()
        const [data,setData]=useState<any>()
      const [dataLoading,setdDataLoading]=useState<any>(false)



const getControllerLookupConfigDataAsync=async()=>{
  setdDataLoading(false)
  try{
  const res=await getDataAsync(systemUsedInFormula.baseURL,systemUsedInFormula.endpoint)
  setData(res)
  }catch{}

  setdDataLoading(true)
  
}

  function extractSimpleFormula(input) {
    // اول: حذف بازگشتی Number(...)
    // function removeNumberWrappers(str) {
    //   while (/Number\s*\(/.test(str)) {
    //     str = str.replace(
    //       /Number\s*\(((?:[^()]+|\([^()]*\))*)\)/g,
    //       (_, inner) => inner
    //     );
    //   }
    //   return str;
    // }

    let output = input?.replace(/\?\.\[[^\]]*\]/g, "");

    // حذف DynamicFormRef.current، ?، .value و چیزای اضافی به صورت دقیق
    output = output
      ?.replace(/newObj\.current/g, "") // حذف DynamicFormRef.current کامل
      .replace(/\b([a-zA-Z_][a-zA-Z0-9_]*)Object\?\./g, "$1.")
      .replaceAll("?.", "") // حذف علامت سوال
     // .replaceAll(".value", "") // حذف .value
     // .replace(/(?<!Math)(?<!\d)\.([a-zA-Z_][a-zA-Z0-9_]*)/g, "$1") // حذف نقاط اضافه
      .replace(/\s+/g, " ") // حذف فاصله های اضافی
      .trim();

    return output;
  }


  useEffect(()=>{
    if(newFormula){
      setSystemUsedInFormula(systemKeys.flatMap(item=>item.inputList)?.find(item=>{return newFormula?.endsWith(item?.SystemKey+'.')}))
    }
  },[newFormula])

  useEffect(()=>{
  if(systemUsedInFormula && systemUsedInFormula?.baseURL,systemUsedInFormula?.endpoint){
    getControllerLookupConfigDataAsync()
  }
  },[systemUsedInFormula])

  return (
    <>
{  (object?.SystemKey!='SystemNumber' && object?.typeName!='price') &&   
  
          <Textbox
            textboxType={
              object?.typeName === "text"
                ? "text"
                : object?.typeName === "textArea"
                ? "textarea"
                : "number"
            }
            textboxName="defaultValue"
            labelText="defaultValue"
            defaultValue={object?.defaultValue}
          />
     

     }


             

 {  object?.SystemKey!='SystemNumber' && 

          <Textbox
            textboxType={"text"}
            fixedLanguage={"en"}
            onChange={(e)=>setNewFormula(e.target.value)}
            textboxName="Formula"
            labelText="Formula"
            defaultValue={extractSimpleFormula(Formul?.[object?.SystemKey])}
          />
  

}


{
systemUsedInFormula?

systemUsedInFormula?.typeName=='items'?
      <div className="col-12 mb-2">
            <SelectBox
              //  onChange={(e) =>{ setObjectKey(e.target.value);setNewFormula(newFormula+e.target.value)}}
                value={null}
                val={systemKeys.flatMap(item=>item.inputList)?.some(item=>{return newFormula?.endsWith(item?.SystemKey+'.')})?["Id","Code","Description","TechnicalCode","MainUnit","StatisticalUnit"]:[]}
                options={systemKeys.flatMap(item=>item.inputList)?.some(item=>{return newFormula?.endsWith(item?.SystemKey+'.')})?["Id","Code","Description","TechnicalCode","MainUnit","StatisticalUnit"]:[]}
                selectType="select"
                name="objectKey"
                lable="کلید های موجود(راهنما)"
               // mode={?'create':'view'}
               useTrans={false}
              />
      </div>
:     <div className="col-12 mb-2">
  
      { dataLoading?  <SelectBox
              //  onChange={(e) =>{ setObjectKey(e.target.value);setNewFormula(newFormula+e.target.value)}}
                value={null}
                val={!!data?.length?Object.keys(data[0]):[]}
                options={!!data?.length?Object.keys(data[0]):[]}
                selectType="select"
                name="objectKey"
                lable="کلید های موجود(راهنما)"
               // mode={?'create':'view'}
               useTrans={false}
              />
            :<InputLoad onClick={getControllerLookupConfigDataAsync}  labelText="کلید های موجود(راهنما)"/>
            
            }
</div>
:<></>
}

      <div className="col-12">
        {(listTypeText && object?.SystemKey!='SystemNumber'&&
          object?.typeName !== "textArea" &&
          object?.typeName !== "number" && object?.typeName !== "decimalNumber" && object?.typeName != "price") && (
            <div>
              <SelectBox
                onChange={(e) => checkTypeText(e.target.value)}
                value={object.InputType || 1}
                val={Object.keys(listTypeText)}
                options={Object.values(listTypeText)}
                selectType="select"
                name="InputType"
                lable="InputType"
              />
            </div>
          )}
      </div>
{   object?.typeName!='price' &&   <div className="col-12 mt-2">
        <div>
          <Textbox
            textboxType="text"
            textboxName="placeholder"
            labelText="placeholder"
            defaultValue={object?.placeholder}
          />
        </div>
      </div>}
      {(textType === "text"&& object?.SystemKey!='SystemNumber' &&  object?.typeName!='price') && (
        <div className="col-12">
          <div>
            <Textbox
              labelText="maxLength"
              textboxName="maxLength"
              textboxType="number"
              defaultValue={object?.maxLength}
            />
          </div>
        </div>
      )}
      {(object?.typeName === "textArea" && object?.SystemKey!='SystemNumber' &&  object?.typeName!='price') && (
        <Textbox
          minHeight={object?.minHeight}
          textboxType="text"
          textboxName="minHeight"
          labelText="minHeight"
          defaultValue={object?.minHeight}
        />
      )}
      {(textType === "other" || textType === "number") && (
        <>
          {maxLengthBox !== minLengthBox || minLengthBox === null ? (
            <>
              <div className="col-12">
                <div>
                  <Textbox
                    textboxType="number"
                    textboxName={textType === "other" ? "minLengthBox" : "min"}
                    labelText={textType === "other" ? "minLengthBox" : "min"}
                    defaultValue={
                      textType === "other"
                        ? minLengthBox || object.minLengthBox
                        : object.min
                    }
                    mode={modeTextBox}
                  />
                </div>
              </div>
              <div className="col-12">
                <div>
                  <Textbox
                    textboxType="number"
                    textboxName={textType === "other" ? "maxLengthBox" : "max"}
                    labelText={textType === "other" ? "maxLengthBox" : "max"}
                    defaultValue={
                      textType === "other"
                        ? maxLengthBox || object.maxLengthBox
                        : object.max
                    }
                    mode={modeTextBox}
                  />
                </div>
              </div>
            </>
          ) : (
            <div className="col-12">
              <div>
                <Textbox
                  textboxType="number"
                  textboxName="setMaxLengthBox"
                  labelText="setMaxLengthBox"
                  defaultValue={maxLengthBox}
                  mode={modeTextBox}
                />
              </div>
            </div>
          )}
        </>
      )}
    </>
  );
};
